import { ProductsPage } from '@/pages/products';

import { useAuthFlow } from '@/shared/auth';
import { FullScreenLoader } from '@/shared/ui';

import { Layout } from './Layout';

export function Root() {
  const { roles } = useAuthFlow();

  if (roles.includes('owner') || roles.includes('admin')) {
    window.location.replace(process.env.PUBLIC_WORKSPACE_ADMIN_URL!);
    return <FullScreenLoader />;
  }

  // This code is not needed now since Communication App is available to all users, but could be needed in the future
  //
  // for (const product of PRODUCTS) {
  //   if (workspaceRoles.every(role => role.startsWith(product.prefix))) {
  //     window.location.replace(product.url);
  //     return <FullScreenLoader />;
  //   }
  // }

  return (
    <Layout>
      <ProductsPage />
    </Layout>
  );
}
